import React from 'react';
import styled from 'styled-components';
import ProgressBar from '@design-system/progress-bar';
import { ETheme } from '@datatype/type';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';

interface IProps {
  currentProgress: number;
  totalProgress: number;
  loading?: boolean;
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const HeaderProgress: React.FC<IProps> = ({ currentProgress, totalProgress, loading = false }) => {
  const ratio = totalProgress === 0 ? 0 : (currentProgress + 1) / totalProgress;
  return (
    <Wrapper>
      <ProgressBar
        ratio={ratio}
        theme={ETheme.YELLOW}
        width={IS_IYAGIGO_MOBILE_VIEW ? '100%' : '400px'}
        height='16px'
        text={`${currentProgress + 1} / ${totalProgress}`}
        loading={loading}
      />
    </Wrapper>
  );
};

export default HeaderProgress;
